const BASE = "/admin";

export const ROUTES = {
  login: "/login",
  oauthCallback: "/auth/oauth/callback",

  dashboard: BASE,

  users: {
    list: `${BASE}/users`,
    detail: (id: string) => `${BASE}/users/${id}`,
    edit: (id: string) => `${BASE}/users/${id}/edit`,
  },

  tenants: {
    list: `${BASE}/tenants`,
    create: `${BASE}/tenants/new`,
    detail: (id: string) => `${BASE}/tenants/${id}`,
    edit: (id: string) => `${BASE}/tenants/${id}/edit`,
  },

  payments: {
    list: `${BASE}/payments`,
    verification: `${BASE}/payments/verification`,
    detail: (id: string) => `${BASE}/payments/${id}`,
  },

  orders: {
    list: `${BASE}/orders`,
    detail: (id: string) => `${BASE}/orders/${id}`,
  },

  products: {
    list: `${BASE}/products`,
    create: `${BASE}/products/new`,
    edit: (id: string) => `${BASE}/products/${id}`,
    pricing: (id: string) => `${BASE}/products/${id}/pricing`,
    pricingDetail: (id: string, pricingId: string) =>
      `${BASE}/products/${id}/pricing/${pricingId}`,
  },

  pricing: {
    components: `${BASE}/pricing/components`,
    componentDetail: (id: string) => `${BASE}/pricing/components/${id}`,
    prices: `${BASE}/pricing/prices`,
  },

  resources: {
    list: `${BASE}/resources`,
    detail: (id: string) => `${BASE}/resources/${id}`,
  },

  osImages: {
    list: `${BASE}/os-images`,
    create: `${BASE}/os-images/create`,
    // No `detail`: the read-only detail page is gone, the edit form is the image's page.
    edit: (id: string) => `${BASE}/os-images/${id}/edit`,
  },

  invoices: {
    detail: (id: string) => `${BASE}/invoices/${id}`,
  },

  audit: `${BASE}/audit`,
  apiKeys: `${BASE}/api-keys`,
  invites: `${BASE}/invites`,
  productLines: {
    list: `${BASE}/product-lines`,
    edit: (id: string) => `${BASE}/product-lines/${id}`,
  },
  billingDiscounts: `${BASE}/billing-discounts`,

  settings: {
    root: `${BASE}/settings`,
    exchangeRates: `${BASE}/settings/exchange-rates`,
    exchangeRateHistory: (currency: string) =>
      `${BASE}/settings/exchange-rates/${currency}/history`,
  },

  platformSettings: `${BASE}/platform-settings`,
  emailTemplates: `${BASE}/email-templates`,

  tpaygate: `${BASE}/tpaygate`,
  tpaygateWebhookSimulator: `${BASE}/tpaygate/webhook-simulator`,
} as const;
